<template>
  <div class="img_box" @click="gosdkAuth(1,'insAuth.html?platform=bcnewpay')">
    <img class="login_other_img" src="../../../assets/img/h5_login_icon02.png" />
  </div>
</template>
<script>
var _self;
import { myMixin } from "@/tools/mixins.js";
export default {
  name: "LoginInstagram",
  mixins: [myMixin],
  data() {
    return {
     
    };
  },
  mounted() {
    _self = this;
    let type = this.getParamsHash('type');
    let id = this.getParamsHash('uid');
    let at = this.getParamsHash('at');
    if(type==='ins'&&id&&at){
      this.confirmLogin(10,{
        "uid":id,
        "accessToken":at
      });
    }
  },
  methods: {
    
  }
};
</script>
<style scoped>
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSdk/LoginSdkInstagram.vue